__turbopack_context__.v({
  "actionButton": "_477hpa_actionButton",
  "actionButtonWrapper": "_477hpa_actionButtonWrapper",
  "carCardFooter": "_477hpa_carCardFooter",
  "carCardFooterSection": "_477hpa_carCardFooterSection",
  "carFeatureItem": "_477hpa_carFeatureItem",
  "carFeatures": "_477hpa_carFeatures",
  "carHeader": "_477hpa_carHeader",
  "carImage": "_477hpa_carImage",
  "carInformationDetails": "_477hpa_carInformationDetails",
  "carItem": "_477hpa_carItem",
  "carItemContent": "_477hpa_carItemContent",
  "carItemContentSelected": "_477hpa_carItemContentSelected",
  "carItemSelected": "_477hpa_carItemSelected",
  "carName": "_477hpa_carName",
  "carRentalCard": "_477hpa_carRentalCard",
  "legalMenuBar": "_477hpa_legalMenuBar",
  "legalMenuBarSeparator": "_477hpa_legalMenuBarSeparator",
  "link": "_477hpa_link",
  "onRequest": "_477hpa_onRequest",
  "price": "_477hpa_price",
  "priceDetail": "_477hpa_priceDetail",
  "yourSelectionBadge": "_477hpa_yourSelectionBadge",
});
